export enum DashboarPageActionTypes {
    CHANGE_COPY_CHARTS = '@@cdashboardPage/CHANGE_COPY_CHARTS',      
    CHANGE_CHARTS = '@@cdashboardPage/CHANGE_CHARTS',
    CHANGE_CHARTS_GET_LOAD = '@@cdashboardPage/CHANGE_CHARTS_GET_LOAD',
    CHANGE_CHART_DATA = '@@cdashboardPage/CHANGE_CHART_DATA',
    CHANGE_CHARTLAYOUTS = '@@cdashboardPage/CHANGE_CHARTLAYOUTS',
    CHANGE_CHARTS_SHOWBTNONHOVER = '@@cdashboardPage/CHANGE_CHARTS_SHOWBTNONHOVER',
    CHANGE_CHARTS_FILTER='@@cdashboardPage/CHANGE_CHARTS_FILTER',
    CHANGE_CHARTS_DIM='@@cdashboardPage/CHANGE_CHARTS_DIM',

    CHANGE_CHARTS_LOCATION = '@@cdashboardPage/CHANGE_CHARTS_LOCATION',    
    CHANGE_CHARTS_GET = '@@cdashboardPage/CHANGE_CHARTS_GET',
    CHANGE_PUBLICSHARE_CHARTS_GET = '@@cdashboardPage/CHANGE_PUBLICSHARE_CHARTS_GET',
    CHANGE_LANDING_CHARTS_GET = '@@cdashboardPage/CHANGE_LANDING_CHARTS_GET',
    CHANGE_CHARTS_COPY = '@@cdashboardPage/CHANGE_CHARTS_COPY',
    CHANGE_CHARTS_VIEW = '@@cdashboardPage/CHANGE_CHARTS_VIEW',
    CHANGE_CHARTS_DELETE_FROMPAGE = '@@cdashboardPage/CHANGE_CHARTS_DELETE_FROMPAGE',
    CHANGE_CHARTS_UPDATE_FROMPAGE = '@@cdashboardPage/CHANGE_CHARTS_UPDATE_FROMPAGE',
    CHANGE_LAYOUT_UPDATE_FROMPAGE = '@@cdashboardPage/CHANGE_LAYOUT_UPDATE_FROMPAGE',
    CHANGE_ONLY_LAYOUT_UPDATE_FROMPAGE = '@@cdashboardPage/CHANGE_ONLY_LAYOUT_UPDATE_FROMPAGE',

    CHANGE_CHARTS_COPY_SUCCESS = '@@cdashboardPage/CHANGE_CHARTS_COPY_SUCCESS',

    CHANGE_FILTERMENU_ADD = '@@cdashboardPage/CHANGE_FILTERMENU_ADD',
    CHANGE_FILTERMENU_EDIT = '@@cdashboardPage/CHANGE_FILTERMENU_EDIT',
    CHANGE_FILTERMENU_DELETE = '@@cdashboardPage/CHANGE_FILTERMENU_DELETE',

    CHANGE_FILTERMENU_ADD_SUCCESS = '@@cdashboardPage/CHANGE_FILTERMENU_ADD_SUCCESS',


    CHANGE_FILTERMENULIST = '@@cdashboardPage/CHANGE_FILTERMENULIST',
    CHANGE_FILTERMENULIST_GET ='@@cdashboardPage/CHANGE_FILTERMENULIST_GET',
    CHANGE_PUBLICFILTERMENULIST_GET ='@@cdashboardPage/CHANGE_PUBLICFILTERMENULIST_GET',
    CHANGE_FILTERMENULIST_GET_LOAD ='@@cdashboardPage/CHANGE_FILTERMENULIST_GET_LOAD',
    CHANGE_FILTERMENUDATA = '@@cdashboardPage/CHANGE_FILTERMENUDATA',

    CHANGE_FILTERMENUVALUE = '@@cdashboardPage/CHANGE_FILTERMENUVALUE',
    CHANGE_DRILLVALUE = '@@cdashboardPage/CHANGE_DRILLVALUE',
    CHANGE_DRILLTroghVALUE = '@@cdashboardPage/CHANGE_DRILLTroghVALUE',
    CHANGE_DRILLFILTERVALUE = '@@cdashboardPage/CHANGE_DRILLFILTERVALUE',

    CHANGE_CHARTTYPEDASH = '@@cdashboardPage/CHANGE_CHARTTYPEDASH',
    CHANGE_IS_SLIDESHOW='@@cdashboardPage/CHANGE_IS_SLIDESHOW', 
    CHANGE_IS_SLIDESHOWPAUSE='@@cdashboardPage/CHANGE_IS_SLIDESHOWPAUSE',
    CHANGE_IS_CHANGELAYOUT='@@cdashboardPage/CHANGE_IS_CHANGELAYOUT', 
    CHANGE_CHANGELAYOUT='@@cdashboardPage/CHANGE_CHANGELAYOUT', 
}
